import Resource from '@/plugins/sdk/Resource'
import { BOOLEAN, STRING, UUID } from '@/plugins/sdk/fields'
// import Account from '@/plugins/sdk/resources/Account'
// import CarrierService from '@/plugins/sdk/resources/Account/CarrierSetting'

export default class extends Resource {
  static name = 'account_itemsdg'

  static get fields () {
    return {
      'id': new UUID(),
      'itemdg_prodclass': new STRING(),
      'itemdg_propname': new STRING(),
      'itemdg_comname': new STRING(),
      'itemdg_hazclass': new STRING(),
      'itemdg_unno': new STRING(),
      'itemdg_hazcode': new STRING(),
      'itemdg_packgroup': new STRING(),
      'itemdg_flashpt': new STRING(),
      'itemdg_addinfo': new STRING(),
      'itemdg_marpol': new BOOLEAN(),
      'itemdg_packtype': new STRING(),
      'itemdg_subrisk': new STRING(),
      'itemdg_packinst': new STRING(),
      'itemdg_apicode': new STRING()
    }
  }

  static get sortables () {
    return [
      { field: 'itemdg_prodclass', label: 'Product Class' },
      { field: 'itemdg_propname', label: 'Proper Shipping Name' },
      { field: 'itemdg_comname', label: 'Common Name' },
      { field: 'itemdg_hazclass', label: 'Hazard Class' },
      { field: 'itemdg_unno', label: 'UN Number' },
      { field: 'itemdg_hazcode', label: 'Hazard Code' },
      { field: 'itemdg_packgroup', label: 'Packing Group' },
      { field: 'itemdg_flashpt', label: 'Flash Point' },
      { field: 'itemdg_marpol', label: 'MARPOL' }
    ]
  }
}
